<label for="feature_{{ feature.id }}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
  @if (feature.comment) {
    <span nbTooltip="{{ feature.comment }}"><tui-icon icon="lightbulb"/></span>
  }
</label>

<div class="accordion-item__right">
  <div class="composite-chips">
    @for (chip of chips; track $index) {
      <span class="composite-chip-wrap">
        @if (chip.empty && chip.header) {
          <span class="composite-chip__header">{{ chip.header }}</span>
        }
        <span class="composite-chip" [ngClass]="{ 'composite-chip--empty': chip.empty }">{{ chip.text }}</span>
      </span>
    }
    @if (!chips.length) {
      <span class="composite-chips__placeholder" i18n="@@SostavHarakteristikiNeZadan">Состав характеристики не задан</span>
    }
  </div>

  <div class="accordion-item__right-info">
    <div class="item">
      @if (hasEmptyPart()) {
        <div class="state-err">
          <tui-icon icon="circle-alert"/>
        </div>
      }
      <span class="composite-badge"
            i18n-nbTooltip="@@ZnachenieSostavnoyHarakteristikiSobiraet2" nbTooltip="Значение составной характеристики собирается автоматически из её частей" i18n="@@Avto">
        авто
      </span>

      @if (featureLink) {
        <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
           class="entityID"
           target="_blank"
           i18n-nbTooltip="@@OpenFeatureInNewWindow"
           nbTooltip="Открыть характеристику в новом окне">
          #{{ feature.featureId }}
        </a>
      }
    </div>
  </div>
</div>
